<div
  class="ui label warning-label"
  [ngStyle]="{
    backgroundColor: color ? color : '',
    color: textColor ? textColor : ''
  }"
>
  <img *ngIf="icon" src="assets/icons/Icon.svg" alt="" />
  {{ data ? data : warning }}
</div>
